module.exports = __webpack_public_path__ + "img/logo.9aef8290.png";